import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, ADMIN_PATH } from "../../lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("ar-SA", { dateStyle: "medium", timeStyle: "short" });

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/registrations").then((r) => setRecent(r.data.slice(0, 8)));
  }, []);

  if (!stats) return <div className="page-loader"><span className="loader" /></div>;
  const cards = [
    ["الفرص البحثية", stats.opportunities, `${stats.open_opportunities} متاحة`, "opportunities"],
    ["التسجيلات", stats.registrations, `${stats.pending_registrations} بانتظار الاعتماد`, "registrations"],
    ["المنسّقون", stats.coordinators, `${stats.pending_coordinators} بانتظار الاعتماد`, "coordinators"],
    ["الإنجازات", stats.achievements, "منشورة في الموقع", "achievements"],
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="admin-top"><div><span className="kicker">Overview</span><h1>نظرة عامة</h1></div></div>
      <div className="stat-grid">{cards.map(([l, v, s, path]) => <Link to={`${ADMIN_PATH}/panel/${path}`} className="stat" key={l} data-testid={`stat-${l}`}><small>{l}</small><b>{v}</b><i>{s}</i></Link>)}</div>
      <div className="admin-top" style={{ marginBottom: 12 }}><h2 style={{ fontSize: 17, fontWeight: 800 }}>آخر التسجيلات</h2><Link to={`${ADMIN_PATH}/panel/registrations`} className="btn btn-ghost btn-sm" data-testid="dashboard-all-registrations">عرض الكل<ArrowLeft size={15} /></Link></div>
      <div className="table-wrap"><table className="tbl"><thead><tr><th>المسجّل</th><th>الفرصة</th><th>الحالة</th><th>التاريخ</th></tr></thead>
        <tbody>{recent.length === 0 ? <tr><td colSpan={4} className="muted" style={{ textAlign: "center", padding: 32 }}>لا توجد تسجيلات بعد</td></tr>
          : recent.map((r) => <tr key={r.id}><td><b>{r.full_name}</b><br /><small className="muted en">{r.phone}</small></td><td><span className="badge badge-indigo">{r.specialty_label}</span></td><td><span className={`badge ${r.access_code ? "badge-green" : "badge-hot"}`}>{r.status}</span></td><td style={{ fontSize: 12 }}>{fmt(r.created_at)}</td></tr>)}
        </tbody></table></div>
    </div>
  );
}
